/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServerState } from '../../models/server-state';

export interface GetServerState$Params {
}

export function getServerState(http: HttpClient, rootUrl: string, params?: GetServerState$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerState>> {
  const rb = new RequestBuilder(rootUrl, getServerState.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServerState>;
    })
  );
}

getServerState.PATH = '/';
